export default __webpack_public_path__ + "static/media/27.3f084ac2.jpg";